import { Env } from 'src/config';

export const environment: Env = {
  name: 'production',
  production: true,
  apiUrl: 'https://' + location.host, // platform.renderseo.com',
  WSSUrl: location.protocol.replace(/^http/, 'ws') + '//' + location.host + '/connect', // 'wss://platform.renderseo.com/connect'
  mapbox: {
    accessToken: 'pk.eyJ1IjoicmVuZGVyc2VvIiwiYSI6ImNtZGRtYTEzazA2N2wycm9mZ2cwOWM2bXgifQ.fnNEUsVQhr3b1qJF4_1AlA',
    style: 'mapbox://styles/mapbox/streets-v11',
  },
};
